<template>
  <div class="ssl-page">
    <div class="form-wrapper">
      <div class="form-main">
        <h2 class="form-title">申请{{this.info.name}}证书</h2>

        <div class="form-group">
          <label for="domain-input">请输入证书绑定的域名</label>
          <textarea id="domain-input" v-model="form.domains" rows="4" placeholder="请输入证书要绑定的域名，一行一个域名"></textarea>
          <p class="form-tip">
            1. 如果您希望一张证书包含多个域名，每个域名之间使用回车(Enter键)换行输入。<br />
            2. 支持多个通配域名，例如：*.domain.com —— 一张证书支持所有子域名，不限制使用
          </p>
        </div>

        <div class="form-group">
          <label>请选择证书语言</label>
          <div class="radio-group">
            <label><input type="radio" name="lang" value="zh" v-model="form.language" /> 中文（证书中显示中文单位名称）</label>
            <label><input type="radio" name="lang" value="en" v-model="form.language" /> 英文（证书中显示英文单位名称）</label>
          </div>
        </div>

        <div class="form-group">
        <label for="year-select">请选择申请年限</label>
        <select id="year-select" v-model="form.years">
            <option v-for="item in yearOptions" :key="item.value" :value="item.value">
            {{ item.label }}
            </option>
        </select>
        <p class="form-tip orange">
            更多年限，低至9折，一次付款，先发最大年限，剩余年限到期前自动补发
        </p>
        </div>

        <div class="form-group">
          <div class="user-info-header">
            <label>请填写使用者信息</label>
            <button class="btn-add" @click="dialogVisible = true">添加新用户</button>
          </div>
          <el-table
            :data="userList"
            style="width: 100%; margin-top: 10px"
            empty-text="暂无用户信息"
            border
          >
            <el-table-column prop="name" label="用户名" />
            <el-table-column prop="email" label="用户邮箱" />
            <el-table-column prop="phone" label="手机号" />
          </el-table>
        </div>

        <div class="form-submit">
          <button @click="pay" class="submit-btn">提交订单</button>
        </div>
      </div>

      <div class="form-summary">
        <div class="summary-box">
          <p class="now-price">现价：<span class="highlight">￥{{this.info.price}}.00</span></p>
          <p>原价：￥{{this.info.price}}.00</p>
          <p>节省：￥1998.00</p>
          <hr />
          <p><strong>{{this.info.name}}</strong></p>
          <p>有效年限：{{this.form.years}}年</p>
          <p>域名数量：0</p>
          <p>证书颁发后绑定的域名：</p>
        </div>
      </div>
    </div>

    <el-dialog
      title="扫码支付"
      :visible.sync="qrDialogVisible"
      width="300px"
      center>
      <div style="text-align: center;">
        <img :src="qrCodeUrl" alt="支付二维码" style="width: 250px; height: 250px;" />
        <p style="margin-top: 10px;">请使用支付宝扫码支付</p>
      </div>
    </el-dialog>

    <el-dialog
      title="添加新用户"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form :model="userForm" label-width="100px">
        <el-form-item label="申请人姓名">
          <el-input v-model="userForm.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="申请人 Email">
          <el-input v-model="userForm.email" placeholder="请输入 Email" />
        </el-form-item>
        <el-form-item label="联系人手机号">
          <el-input v-model="userForm.phone" placeholder="请输入手机号" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="handleAddUser">添加</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { APICreateOrder,APIAlipay } from "@/api/user.js";
export default {
  data() {
    return {
      form: {
        years: 1,
        domains: '',
        language: 'zh', // 默认中文
      },
      yearOptions: [
        { value: 1, label: '1年' },
        { value: 2, label: '2年' }
      ],
      info: {},
      dialogVisible: false, // 控制弹窗显示
      userForm: {
        name: '',
        email: '',
        phone: ''
      },
      userList: [],
      qrDialogVisible: false,
      qrCodeUrl: '',
    };
  },
  mounted() {
    // console.log(this.$route.params.info)
    this.info = this.$route.params.info;
  },
  methods: {
    handleAddUser() {
      // 简单校验
      if (!this.userForm.name || !this.userForm.email || !this.userForm.phone) {
        this.$message.warning("请填写完整的用户信息");
        return;
      }

      // 添加用户
      this.userList.push({ ...this.userForm });

      // 清空表单
      this.userForm = {
        companyName: '',
        companyNameEn: '',
        companyPhone: '',
        name: '',
        email: '',
        phone: '',
      };

      // 关闭弹窗
      this.dialogVisible = false;
    },
async pay() {
  try {
    // 参数整理
    const domainList = this.form.domains.split('\n').map(d => d.trim()).filter(d => d);
    const params = {
      domains: domainList,
      language: this.form.language,
      years: this.form.years,
      users: this.userList
    };

    // ✅ 校验开始
    if (!domainList.length) {
      this.$message.warning("请输入至少一个有效的域名");
      return;
    }

    if (!params.language) {
      this.$message.warning("请选择证书语言");
      return;
    }

    if (!params.years) {
      this.$message.warning("请选择申请年限");
      return;
    }

    if (!params.users.length) {
      this.$message.warning("请至少添加一位用户信息");
      return;
    }

    for (const user of params.users) {
      if (!user.name || !user.email || !user.phone) {
        this.$message.warning("每位用户的姓名、邮箱、手机号均不能为空");
        return;
      }
    }

    await APICreateOrder({
      subject: 'SSL证书',
      price: this.info.price,
      ...params
    }).then(res => {
      if (res.code === 200) {
        APIAlipay({
          orderId: res.orderId,
          price: res.total_amount
        }).then(response => {
          const blob = new Blob([response.data], { type: 'image/png' });
          const url = URL.createObjectURL(blob);
          console.log('二维码 Blob URL：', url);
          const src = window.URL.createObjectURL(response); // 你原来的写法我也保留了
          this.qrCodeUrl = src;
          // this.qrCodeUrl = url;
          this.qrDialogVisible = true;
        });
      } else {
        this.$message.error('订单创建失败，请稍后再试');
      }
    });
  } catch (e) {
    console.error(e);
    this.$message.error('网络错误');
  }
}



  },
}
</script>
<style scoped>

.form-wrapper {
    width: 80%;
    margin: 20px auto;
    display: flex;
    align-items: flex-start;
    gap: 40px;
    text-align: left;
}
.form-main {
  flex: 3;
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.05);
}
.form-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}
.form-group {
  margin-bottom: 24px;
}
label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}
textarea,
select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}
.radio-group {
  display: flex;
  gap: 20px;
  font-size: 14px;
}
.form-tip {
  font-size: 12px;
  color: #888;
  margin-top: 6px;
  line-height: 1.5;
}
.orange {
  color: #f60;
}
.user-info-header {
  display: flex;
  justify-content: space-between;
}
.btn-add {
  background: #0b8b4c;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.user-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: #fafafa;
  font-size: 13px;
}
.user-table th,
.user-table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #eee;
}
.form-submit {
  text-align: left;
  margin-top: 20px;
}
.submit-btn {
  background: #2979ff;
  color: white;
  padding: 10px 24px;
  font-size: 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.form-summary {
  flex: 1;
  min-width: 240px;
}
.summary-box {
  background: #fff;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 8px;
  font-size: 14px;
}
.highlight {
  color: red;
  font-weight: bold;
  font-size: 18px;
}
</style>
